// extracted by mini-css-extract-plugin
export default {"game":"Gamecard_game__v6znb","logo":"Gamecard_logo__4QgZK","winnerLogo":"Gamecard_winnerLogo__--Axi","active":"Gamecard_active__622hA","highlight":"Gamecard_highlight__BOP2n"};